import React, { FC } from 'react'

import { type AppBottomBarIconProps } from '../../types'

import styles from './ButtonBarButton.module.scss'

interface BottomBarButtonProps {
  onClick?: () => void
  icon: React.FC<AppBottomBarIconProps>
  label?: string
  isActive: boolean
}

export const BottomBarButton: FC<BottomBarButtonProps> = ({
  isActive,
  label,
  icon: Icon,
  onClick
}) => {
  return (
    <button onClick={onClick} className={styles.BottomBarButton}>
      {<Icon isActive={isActive} />}
      {isActive ? <div className={styles.label}>{label}</div> : null}
    </button>
  )
}
